import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Allowed_Route } from 'src/shared/constant/allowed-route-const';

import { RoutingUrl } from '../constant/route-const';
import { StorageWrapperService } from '@workflow/ecp-shared/service/storage-wrapper/storage-wrapper.service';
import { Info, RouterUrlConstant } from '@workflow/ecp-shared/constant/information.const';

/**
 * class PathGuardService
 */
@Injectable()
export class PathGuardService {
  constructor(private readonly router: Router, private readonly storageWrapperService: StorageWrapperService) {}

  /**
   * Class representing the auth service.
   */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (state.url === '/') {
      this.router.navigate([RoutingUrl.Login]);
      return false;
    }
    const alloweroute = this.storageWrapperService.get(Info.allowedRoute);

    if (
      state.url.startsWith(RouterUrlConstant.application) &&
      (alloweroute === Allowed_Route.Consumer_PostApp || alloweroute === Allowed_Route.Mortgage_PostApp)
    ) {
      this.navigateToRoot();
      return false;
    }

    if (state.url.startsWith(RouterUrlConstant.mortgagePostapp) && alloweroute !== Allowed_Route.Mortgage_PostApp) {
      this.storageWrapperService.set('nextStateUrl', state.url);
      this.navigateToRoot();
      return false;
    }

    if (state.url.startsWith(RouterUrlConstant.consumerPostapp) && alloweroute !== Allowed_Route.Consumer_PostApp) {
      this.navigateToRoot();
      return false;
    }

    if (state.url.startsWith(RouterUrlConstant.oaoPostapp) && alloweroute !== Allowed_Route.OAO_PostApp) {
      this.navigateToRoot();
      return false;
    }

    return true;
  }

  private navigateToRoot(): void {
    this.router.navigate(['/']);
  }
}
